var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("box", { attrs: { background: "white", "no-shadow": "" } }, [
    _c(
      "div",
      { attrs: { slot: "header" }, slot: "header" },
      [
        _c("share", { attrs: { url: _vm.shareUrl } }),
        _vm._v(" "),
        _c("print", { attrs: { "map-view-data": _vm.mapViewData } }),
        _vm._v(" "),
        _c("h3", [_vm._v(_vm._s(_vm.$t("placeDetails.placeDetails")))])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _vm.$highResolution
          ? [
              _c("v-img", {
                staticStyle: { width: "100%", "max-height": "250px" },
                attrs: {
                  src: _vm.imagePath,
                  "lazy-src": _vm.imageUrlFallBack,
                  title:
                    _vm.place.placeName +
                    " - " +
                    _vm.$t("placeDetails.satelliteView")
                }
              }),
              _vm._v(" "),
              _c("br")
            ]
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          [
            _vm.place.placeName
              ? _c("div", [
                  _vm._v(_vm._s(_vm.$t("placeDetails.placeName")) + ": "),
                  _c("b", [_vm._v(_vm._s(_vm.place.placeName))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.place.properties.country
              ? _c("div", [
                  _vm._v(_vm._s(_vm.$t("global.layers.country")) + ": "),
                  _c("b", [_vm._v(_vm._s(_vm.place.properties.country))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _vm._v(_vm._s(_vm.$t("placeDetails.layer")) + ": "),
              _c("b", [
                _vm._v(
                  _vm._s(_vm.$t("global.layers." + _vm.place.properties.layer))
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(_vm._s(_vm.$t("placeDetails.lon")) + ": "),
              _c("b", [_vm._v(_vm._s(_vm.place.lng))])
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(_vm._s(_vm.$t("placeDetails.lat")) + ": "),
              _c("b", [_vm._v(_vm._s(_vm.place.lat))])
            ]),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                attrs: {
                  title: _vm.$t("placeDetails.copyLnglat"),
                  flat: "",
                  small: "",
                  icon: ""
                },
                on: {
                  click: function($event) {
                    return _vm.copyLngLat()
                  }
                }
              },
              [_c("v-icon", [_vm._v("content_copy")])],
              1
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass: "copy-inverted",
                attrs: {
                  title: _vm.$t("placeDetails.copyLatlng"),
                  flat: "",
                  small: "",
                  color: "primary",
                  icon: ""
                },
                on: {
                  click: function($event) {
                    return _vm.copyLatLng()
                  }
                }
              },
              [_c("v-icon", [_vm._v("content_copy")])],
              1
            )
          ],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e0e4a6c", { render: render, staticRenderFns: staticRenderFns })
  }
}